import { Navigate, useLocation } from "react-router-dom";
import Loader from "../components/Loader";
import { Card, Col, Container, Row } from "react-bootstrap";
import styles from "./MyAccount.module.scss";
import EditMyAccount from "../components/EditMyAccount";

interface Props {
    user: User | null;
    permissions: Permission[];
    loading: boolean;
}

const MyAccount: React.FC<Props> = ({ user, permissions, loading }) => {
    // Aqui você pode adicionar validações com base em permissões se quiser
    const isAuthenticated = !!user;
    const location = useLocation();

    if (loading) return <Loader />;

    if (!isAuthenticated) {
        return <Navigate to={`/login?continue=${encodeURIComponent(location.pathname)}`} />;
    }

    return (
        <>
            <Container className="my-4">
                <Row className="data-content align-items-center">
                    <Col>
                        <Card className={styles["boas-vindas"]}>
                            <Card.Header className={styles["center"]}>
                                <Card.Title className={styles.h1}>Minha Conta</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                <EditMyAccount user={user} permissions={permissions}/>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default MyAccount;
